import { Project } from 'data/projects';
import { Slide, SlideEditorViewState } from '../providers/SlideEditorProvider';
import { PitchDeck } from 'data/pitchdecks';

export const INITIALIZE_SLIDE_EDITOR = 'INITIALIZE_SLIDE_EDITOR';
export const HANDLE_SETTINGS_SELECT = 'HANDLE_SETTINGS_SELECT';
export const SAVE_PITCHDECK_SETTINGS = 'SAVE_PITCHDECK_SETTINGS';
export const SET_SLIDE_EDITOR_STATE = 'SET_SLIDE_EDITOR_STATE';
export const SET_PROJECT_DATA = 'SET_PROJECT_DATA';
export const SET_PITCH_DECK_DATA = 'SET_PITCH_DECK_DATA';
export const SET_ACTIVE_SLIDE = 'SET_ACTIVE_SLIDE';
export const SET_SLIDE_EDIT_MODE = 'SET_SLIDE_EDIT_MODE';
export const SET_EDIT_MODE = 'SET_EDIT_MODE';
export const SET_SLIDES = 'SET_SLIDES';
export const REMOVE_SLIDE = 'REMOVE_SLIDE';
export const ADD_SLIDE = 'ADD_SLIDE';
export const SET_DELETE_MODAL = 'SET_DELETE_MODAL';
export const SET_UPLOADING = 'SET_UPLOADING';
export const CHANGE_BACKGROUN_SLIDE = 'CHANGE_BACKGROUN_SLIDE';
export const SAVE_SLIDE = 'SAVE_SLIDE';
export const UPDATE_SLIDE = 'UPDATE_SLIDE';
export const SET_UPDATE_BACKGROUND = 'SET_UPDATE_BACKGROUND';

export type SLIDE_EDITOR_ACTION_TYPE =
  | {
      type: typeof INITIALIZE_SLIDE_EDITOR;
      payload: Partial<SlideEditorViewState>;
    }
  | {
      type: typeof HANDLE_SETTINGS_SELECT;
      payload: {
        pitchDeckId: string;
        statusId: string;
        trackingEnabled: boolean;
        openSettingsModal: boolean;
      };
    }
  | { type: typeof SAVE_PITCHDECK_SETTINGS; payload: PitchDeck }
  | {
      type: typeof SET_SLIDE_EDITOR_STATE;
      payload: Partial<SlideEditorViewState>;
    }
  | { type: typeof SET_PROJECT_DATA; payload: Project }
  | { type: typeof SET_PITCH_DECK_DATA; payload: PitchDeck }
  | { type: typeof SET_ACTIVE_SLIDE; payload: number }
  | { type: typeof SET_SLIDE_EDIT_MODE; payload: boolean }
  | { type: typeof SET_EDIT_MODE; payload: boolean }
  | { type: typeof SET_SLIDES; payload: Slide[] }
  | { type: typeof REMOVE_SLIDE; payload: number }
  | { type: typeof ADD_SLIDE; payload: Slide }
  | { type: typeof SET_DELETE_MODAL; payload: boolean }
  | { type: typeof SET_UPLOADING; payload: boolean }
  | {
      type: typeof CHANGE_BACKGROUN_SLIDE;
      payload: { index: number; background: string };
    }
  | { type: typeof SAVE_SLIDE; payload: Slide }
  | { type: typeof UPDATE_SLIDE; payload: Slide }
  | { type: typeof SET_UPDATE_BACKGROUND; payload: boolean };

export const slideEditorReducer = (
  state: SlideEditorViewState,
  action: SLIDE_EDITOR_ACTION_TYPE
): SlideEditorViewState => {
  switch (action.type) {
    case INITIALIZE_SLIDE_EDITOR: {
      const { payload } = action;
      return { ...state, ...payload };
    }
    case HANDLE_SETTINGS_SELECT: {
      const { payload } = action;
      return {
        ...state,
        pitchDeckId: payload.pitchDeckId,
        statusId: payload.statusId,
        trackingEnabled: payload.trackingEnabled,
        openSettingsModal: payload.openSettingsModal
      };
    }
    case SAVE_PITCHDECK_SETTINGS: {
      const { payload } = action;
      return { ...state, pitchDeckData: payload };
    }
    case SET_SLIDE_EDITOR_STATE: {
      const { payload } = action;
      return { ...state, ...payload };
    }
    case SET_PROJECT_DATA: {
      const { payload } = action;
      return { ...state, projectData: payload };
    }
    case SET_PITCH_DECK_DATA: {
      const { payload } = action;
      return { ...state, pitchDeckData: payload };
    }
    case SET_ACTIVE_SLIDE: {
      const { payload } = action;
      return { ...state, activeSlideIndex: payload };
    }
    case SET_EDIT_MODE: {
      const { payload } = action;
      return { ...state, editMode: payload };
    }
    case SET_SLIDE_EDIT_MODE: {
      const { payload } = action;
      return { ...state, slideEditMode: payload };
    }
    case SET_SLIDES: {
      const { payload } = action;
      return { ...state, slides: payload };
    }
    case REMOVE_SLIDE: {
      const { payload: index } = action;
      if (state.slides.length <= 1) {
        return state;
      }
      const updatedSlides = [...state.slides];
      updatedSlides.splice(index, 1);
      const newActiveSlideIndex =
        state.activeSlideIndex >= updatedSlides.length
          ? updatedSlides.length - 1
          : state.activeSlideIndex;

      return {
        ...state,
        slides: updatedSlides,
        activeSlideIndex: newActiveSlideIndex
      };
    }
    case ADD_SLIDE: {
      const { payload: newSlide } = action;
      return { ...state, slides: [...state.slides, newSlide] };
    }
    case SET_DELETE_MODAL: {
      const { payload } = action;
      return { ...state, showDeleteModal: payload };
    }
    case SET_UPLOADING: {
      const { payload } = action;
      return { ...state, uploading: payload };
    }
    case CHANGE_BACKGROUN_SLIDE: {
      const { index, background } = action.payload;
      const updatedSlides = [...state.slides];
      updatedSlides[index] = {
        ...updatedSlides[index],
        background
      };
      return { ...state, slides: updatedSlides };
    }
    case SAVE_SLIDE: {
      const { payload: savedSlide } = action;
      const updatedSlides = [...state.slides];
      updatedSlides[state.activeSlideIndex] = savedSlide;
      return { ...state, slides: updatedSlides };
    }
    case UPDATE_SLIDE: {
      const { payload } = action;
      return { ...state, slide: payload };
    }
    case SET_UPDATE_BACKGROUND: {
      const { payload } = action;
      return { ...state, updateBackground: payload };
    }
    default:
      return state;
  }
};
